import { useSelector } from "react-redux";
import { selectMemberPlan } from "../redux/selectors/plan";
import { MEMBER_PLAN, isPaidPlan, planLabel } from "../utils/memberPlan";

/**
 * The member's plan (Guest / Free / Premium Lite / Premium). Use this — not
 * `subscription_type.name === "premium"`, which is true for Lite too — wherever
 * Lite and Premium must differ.
 */
export function usePlan() {
  const plan = useSelector(selectMemberPlan);

  return {
    plan,
    label: planLabel(plan),
    isPremium: plan === MEMBER_PLAN.PREMIUM,
    isPremiumLite: plan === MEMBER_PLAN.PREMIUM_LITE,
    isPaid: isPaidPlan(plan),
  };
}

export default usePlan;
